import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/services/apiClient";
import { queryKeys } from "@/services/queryClient";
import type { EntitlementsOut, SubscriptionOut } from "@/services/types";

export function useSubscription() {
  return useQuery<EntitlementsOut>({
    queryKey: queryKeys.subscription,
    queryFn: () => api.get("/subscriptions/me"),
  });
}

export function useRedeemCode() {
  const qc = useQueryClient();
  return useMutation<SubscriptionOut, Error, string>({
    mutationFn: (code: string) => api.post("/subscriptions/redeem-code", { code }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.subscription });
    },
  });
}

/**
 * Convenience boolean — does the current user have at least `minTier`?
 * Usage: `if (useEntitlement("pro")) { … }`
 */
export function useEntitlement(minTier: "pro" | "legend"): boolean {
  const { data } = useSubscription();
  if (!data) return false;
  const order = { free: 0, pro: 1, legend: 2 } as const;
  return order[data.tier] >= order[minTier];
}
